// extracted by mini-css-extract-plugin
module.exports = {"shop_box":"shop_box-3PT5u6Kj"};